import React, { Component } from 'react'

import { Close, Chat, Phone, Mail } from '../Icons'
import { PopupContainer, Popup, PopupHeader, PopupTitle, CloseButton } from '../../styles/defaults'
import { ItemLink, Item, IconContainer, Content, Title, Subtitle } from './styles'

class ContactPopup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      chat: 'We zijn nu online'
    }
  }

  handleChat() {
    let Tawk_API = window.Tawk_API || {}
    if (Tawk_API.getStatus()) {
      Tawk_API.toggle()
    }
  }

  handlePhone(e) {
    if (document.body.clientWidth > 1000) {
      e.preventDefault()
    }
  }

  render() {
    if (!this.props.popupActive) {
      return null
    }
    let Tawk_API = window.Tawk_API || {}
    return (
      <PopupContainer className="js-popup-container" onClick={this.props.closePopupContainer}>
        <Popup>
          <PopupHeader>
            <PopupTitle>Contact</PopupTitle>

            <CloseButton onClick={this.props.closePopup}>
              <Close size="xlarge" />
            </CloseButton>
          </PopupHeader>

          <Item onClick={this.handleChat.bind(this)}>
            <IconContainer>
              <Chat size="xlarge" />
            </IconContainer>

            <Content>
              <Title>Start een chat</Title>
              <Subtitle>{`We zijn nu ${Tawk_API.getStatus()}`}</Subtitle>
            </Content>
          </Item>

          <ItemLink href="tel:0182-308000" onClick={this.handlePhone.bind(this)}>
            <Item>
              <IconContainer>
                <Phone size="xlarge" />
              </IconContainer>

              <Content>
                <Title>0182-308000</Title>
                <Subtitle>Direct contact</Subtitle>
              </Content>
            </Item>
          </ItemLink>

          <ItemLink href="/contact">
            <Item>
              <IconContainer>
                <Mail size="xlarge" />
              </IconContainer>

              <Content>
                <Title>Neem contact op</Title>
                <Subtitle>Reactie binnen één werkdag</Subtitle>
              </Content>
            </Item>
          </ItemLink>
        </Popup>
      </PopupContainer>
    )
  }
}

export default ContactPopup



// WEBPACK FOOTER //
// ./src/components/ContactPopup/index.js